enum Plans {
  START_UP = 'Start Up',
  SCALE_UP = 'Scale Up',
  CORPORATE = 'Corporate'
}

export default Plans;
